import "./Reseau.css";
import { useEffect, useState } from "react";
import { get } from "../http/api";
import AdvancedSearch from "./AdvancedSearch";
import NetworkCard from "./NetworkCard";
import { useTranslation } from "react-i18next";


export default function Network() {

  const [suggestions, setSuggestions] = useState([]);
  const [discover, setDiscover] = useState([]);
  const [loading, setLoading] = useState(true);

  const { t } = useTranslation();

  useEffect(() => {
    fetchNetwork();
  }, []);

  const fetchNetwork = async () => {

    try {

      const suggestionsRes = await get("network/suggestions");
      const discoverRes = await get("network/discover");

      setSuggestions(suggestionsRes.data || []);
      setDiscover(discoverRes.data || []);

    } catch (err) {
      console.error(err);
    }

    setLoading(false);

  };

  return (
    <div className="network-page">

      <div className="network-header">
        <h1>{t("network.title")}</h1>
        <p>
          {t("network.subtitle")}
        </p>
      </div>


      <div className="network-section">

        <h2> {t("network.discoverProfiles")} </h2>

        <div className="network-row">

          {loading ? (

            Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="network-skeleton"></div>
            ))

          ) : (

            discover.map(user => (
              <NetworkCard key={user.id} profile={user} />
            ))

          )}

        </div>

      </div>


      <AdvancedSearch />

    </div>
  );
}